import { render } from "./wellControllerBinary.vue?vue&type=template&id=28d2e622&scoped=true"
import script from "./wellControllerBinary.vue?vue&type=script&lang=js"
export * from "./wellControllerBinary.vue?vue&type=script&lang=js"

import "./wellControllerBinary.vue?vue&type=style&index=0&id=28d2e622&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d2e622"]])

export default __exports__